import React from 'react';
import Player from '@vimeo/player';

export default class MeetTheTeam extends React.Component {
  handleClose = () => {
    this.setState({open: false, url: null,  isPlaying : false});
  };

  handleIframeLoad = () => {
    let iframe = document.querySelector('iframe');
    this.player = new Player(iframe);
    window.player = this.player;
  };


  render() {
    const videosArray = [{
      url: '<iframe src="https://player.vimeo.com/video/1088107534?h=06acb17a3a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="width:100%;height:100%;min-height:300px;" title="Introduction to Prescription Revision"></iframe>',
    }];
    const videoItem = videosArray.map((item, index) => {
      return (
        <div key={index} dangerouslySetInnerHTML={{__html: item.url}}></div>
      )
    });

    return (
      <div className="col-md-8" style={{margin: '50px auto 0', zIndex: 1}}>
        <div className="content-wrap">
          <h1 className="section-title intro-title">
            MEET THE TEAM
          </h1>
          {videoItem}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/landing/components/MeetTheTeam.js